import { Directive, HostListener, Inject } from '@angular/core';
import { Executable } from '../executable';
import { UntilDestroy } from '@ngneat/until-destroy';
import { SettingsExecutableService } from './settings-executable.service';

/**
 * Represents a directive that handles the export functionality.
 */
@UntilDestroy()
@Directive({
  selector: '[spSettings]',
  standalone: false,
})
export class SettingsExecutableDirective implements Executable {
  constructor(@Inject(SettingsExecutableService) private settingsExecutableService: Executable) {}

  @HostListener('click', ['$event'])
  execute = (): void => this.settingsExecutableService.execute();
}
